import React, { useMemo } from "react";
import { Box, Button, Card, Chip, Grid, LinearProgress, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const statuses = [
    { label: "Certified", value: 70, amount: "₹ 123 Cr", count: 70, color: "#4C1DFF" },
    { label: "Paid", value: 55, amount: "₹ 95 Cr", count: 55, color: "#B026FF" },
    { label: "Deducted", value: 20, amount: "₹ 5 Cr", count: 20, color: "#E11D48" },
    { label: "Withheld", value: 40, amount: "₹ 12 Cr", count: 40, color: "#F59E0B" },
];

const InvoiceByStatus = () => {


    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #E4E4E4",
                width: '100%',
            }}
        >
            <Box sx={{
                width: '100%',
                borderBottom: "1px solid #E4E4E4",
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0
                    }}>
                        Total number of Invoices by Status
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: '16px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        Invoices breakdown by Status shows the current progress of each invoice
                    </Typography>
                </Box>
            </Box>
            <Grid container>
                <Grid size={{ md: 4 }} sx={{ p: 1.5 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontWeight: 400,
                                fontSize: '18px',
                                letterSpacing: "0px",
                                mb: 2
                            }}
                        >
                            Total Invoices
                        </Typography>

                        <Box sx={{ mb: 4 }}>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontWeight: 400,
                                    fontSize: '28px',
                                    letterSpacing: "0px",
                                    mb: 0
                                }}
                            >
                                185
                                <Typography
                                    component="span"
                                    sx={{
                                        fontFamily: "Outfit, sans-serif",
                                        fontWeight: 400,
                                        fontSize: '20px',
                                        letterSpacing: "0px",
                                        mb: 0
                                    }}
                                >
                                     &nbsp;invoices
                                </Typography>
                            </Typography>
                            <Typography variant="body1" sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontWeight: 400,
                                fontSize: '14px',
                                letterSpacing: "0px",
                                mb: 1
                            }}>
                                of value ₹<b>{"235 Cr"}</b>
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ md: 8 }} sx={{ p: 1.5 }}>
                    <Box
                        sx={{
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                        }}
                    >
                        <Box
                            sx={{
                                width: 150,
                                height: 150,
                                borderRadius: "50%",
                                background:
                                    "conic-gradient(#4C1DFF 0deg 150deg, #B026FF 150deg 230deg, #E11D48 230deg 280deg, #F59E0B 280deg 360deg)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {/* inner white circle */}
                            <Box
                                sx={{
                                    width: 120,
                                    height: 120,
                                    borderRadius: "50%",
                                    backgroundColor: "#ffffff",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontFamily: "Outfit, sans-serif",
                                        fontWeight: 700,
                                        fontSize: '22px',
                                        letterSpacing: "0px",
                                        mb: 0
                                    }}
                                >
                                    {"37"}%
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontFamily: "Outfit, sans-serif",
                                        fontWeight: 300,
                                        fontSize: '14px',
                                        letterSpacing: "0px",
                                        color: '#7D7F81'
                                    }}
                                >
                                    certified
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ md: 12 }} sx={{ p: 1.5 }}>
                    <Stack spacing={1}>
                        {statuses.map((s) => (
                            <Box key={s.label}>
                                <Box sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between"
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{ color: "#374151", mb: 1 }}
                                    >
                                        {s.label}
                                    </Typography>
                                    <Box display={"flex"}>
                                        <Chip
                                            label={s.amount}
                                            size="small"
                                            sx={{
                                                fontSize: 12,
                                                fontWeight: 500,
                                                borderRadius: 999,
                                                backgroundColor: "#e5e7eb",
                                            }}
                                        />
                                        <Typography variant="body2" sx={{ color: "#4b5563" }}>
                                            {s.count}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                    }}
                                >
                                    <Box sx={{ flex: 1 }}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={s.value}
                                            sx={{
                                                height: 6,
                                                borderRadius: 999,
                                                backgroundColor: "#e5e7eb",
                                                "& .MuiLinearProgress-bar": {
                                                    borderRadius: 999,
                                                    backgroundColor: s.color,
                                                },
                                            }}
                                        />
                                    </Box>


                                </Box>
                            </Box>
                        ))}
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    );
};

export default InvoiceByStatus;
